import { useRef } from "react";
import { createDefaultPagination } from "../chatMessageUtils";

export const useChatViewportRefs = () => {
  const sendButtonRef = useRef(null);
  const hiddenFileInput = useRef(null);
  const messagesEndRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const topSentinelRef = useRef(null);
  const bottomSentinelRef = useRef(null);
  const shouldAutoScrollRef = useRef(true);
  const loadOlderMessagesRef = useRef(null);
  const loadNewerMessagesRef = useRef(null);
  const topAutoLoadRef = useRef({ lastAt: 0 });
  const bottomAutoLoadRef = useRef({ lastAt: 0 });
  const topIntersectionLockRef = useRef(false);
  const bottomIntersectionLockRef = useRef(false);
  const topLoadIntentRef = useRef(false);
  const bottomLoadIntentRef = useRef(false);
  const topZoneStateRef = useRef({
    isInside: false,
    hasTriggeredForEntry: false,
  });
  const bottomZoneStateRef = useRef({
    isInside: false,
    hasTriggeredForEntry: false,
  });
  const userScrolledRef = useRef(false);
  const historyBrowseActiveRef = useRef(false);
  const forwardHistoryBrowseActiveRef = useRef(false);
  const previousScrollTopRef = useRef(0);
  const bottomPaginationArmedRef = useRef(true);
  const pendingJumpMessageIdRef = useRef(null);
  const requestVersionRef = useRef({
    initial: 0,
    older: 0,
    newer: 0,
    polling: 0,
    refresh: 0,
    jump: 0,
  });
  const inFlightRef = useRef({
    initial: false,
    older: false,
    newer: false,
    polling: false,
    refresh: false,
    jump: false,
  });
  const initialScrollPendingRef = useRef(false);
  const initialLoadCompleteRef = useRef(false);
  const initialScrollTimersRef = useRef([]);
  const readStateRef = useRef({
    inFlight: false,
    lastMarkedChatId: null,
  });
  const lastSeenIncomingMessageIdRef = useRef(null);
  const paginationRef = useRef(createDefaultPagination());

  const bundleRef = useRef(null);
  if (bundleRef.current === null) {
    bundleRef.current = {
      sendButtonRef,
      hiddenFileInput,
      messagesEndRef,
      scrollContainerRef,
      topSentinelRef,
      bottomSentinelRef,
      shouldAutoScrollRef,
      loadOlderMessagesRef,
      loadNewerMessagesRef,
      topAutoLoadRef,
      bottomAutoLoadRef,
      topIntersectionLockRef,
      bottomIntersectionLockRef,
      topLoadIntentRef,
      bottomLoadIntentRef,
      topZoneStateRef,
      bottomZoneStateRef,
      userScrolledRef,
      historyBrowseActiveRef,
      forwardHistoryBrowseActiveRef,
      previousScrollTopRef,
      bottomPaginationArmedRef,
      pendingJumpMessageIdRef,
      requestVersionRef,
      inFlightRef,
      initialScrollPendingRef,
      initialLoadCompleteRef,
      initialScrollTimersRef,
      readStateRef,
      lastSeenIncomingMessageIdRef,
      paginationRef,
    };
  }

  return bundleRef.current;
};
